import { utilityService } from "shared/services";
import { IOutstandingContractorQuote } from "projects/models";
import { ColumnsType, ROW_INDEX_COLUMN } from "shared/constants";
import { Link } from "react-router-dom";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

export const getOutstandingContractorQuotesColumns = (organization: IOrganization | undefined): ColumnsType<IOutstandingContractorQuote> =>
  [
    ROW_INDEX_COLUMN,
    {
      title: "Project",
      dataIndex: "projectName",
      render: (value, record, index) => (
        <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
          {utilityService.truncateField(value)}
        </Link>
      ),
    },
    {
      title: "Subcontractor",
      dataIndex: "subcontractor",
      render: (value, record, index) => utilityService.truncateField(value),
    },
    {
      title: "Days Since HVAC Assessment Sent",
      dataIndex: "daysSinceHvacAssessmentSent",
      render: (value, record, index) =>
        utilityService.truncateField(`${value} days`),
    },
  ];
